<template>
  <div
    class="flex justify-center bg-cover bg-center bg-fixed bg-transparent text-white"
  >
    <div class="max-w-[920px] w-full mx-[15px] flex flex-col space-y-[25px]">
      <CompaniesTable
        v-if="list.hits"
        :list="list"
        :cols="COLS"
        @next="onNextPage"
      >
        <template #name="{ row }">
          <div>
            {{ row.name }}
          </div>
        </template>

        <template #business="{ row }">
          {{ row.business.map((entry: any) => entry.name).join(', ') }}
        </template>

        <template #country="{ row }">
          {{ row.country?.name }}
        </template>
      </CompaniesTable>
    </div>
  </div>
</template>

<script setup lang="ts">
import CompaniesTable from './components/companies-table.vue'
import { useCompanies } from '~/stores/companies'

definePageMeta({
  layout: false,
})

const COLS = [
  {
    label: 'Name',
    param: 'name',
    className: 'sm:w-[40%]',
  },
  {
    label: 'Primary Business',
    param: 'business',
    className: 'sm:w-[40%]',
  },
  {
    label: 'Country',
    param: 'country',
    className: '',
  },
]

const { initCompaniesList, list, getPage, nextPage } = useCompanies()
const { sendResize } = useFrameBridge()

onMounted(() => {
  nextTick(() => sendResize('companies:mounted'))
})

watch(
  () => list.hits,
  () => {
    process.client && sendResize('companies:watch')
  }
)

const route = useRoute()

async function load() {
  initCompaniesList(route.params.event as string)
  list.params.per_page = 20
  await getPage()
}

onBeforeMount(async () => {
  await load()
})

onServerPrefetch(async () => {
  await load()
})

function onNextPage() {
  nextPage()
}
</script>
